import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode, Thumbs, EffectFade } from "swiper/modules";

/**
 * Componente de testimonios y reseñas de clientes para Leal Chapa y Pintura.
 */
const TestimonialOne = () => {
  return (
    <div
      className="testimonial-area-1 overflow-hidden"
      style={{ backgroundImage: "url(assets/img/bg/testimonial-bg1-1.png)" }}
    >
      <div className="container">
        <div className="row">
          {/* Imagen lateral */}
          <div className="col-lg-6">
            <div className="testimonial-thumb1">
              <img
                src="assets/img/testimonial/testimonial-1-1.png"
                alt="Leal Chapa y Pintura"
              />
            </div>
          </div>

          {/* Sección de testimonios */}
          <div className="col-lg-6">
            <div className="space">
              <div className="title-area">
                <span className="sub-title">Reseñas y Testimonios</span>
                <h2 className="sec-title text-white">
                  Lo Que Nuestros Clientes Opinan
                </h2>
                <p className="sec-text text-white">
                En Leal, tu tranquilidad es nuestra prioridad. Por eso utilizamos materiales
                de primera calidad y ofrecemos garantía de por vida en chapa y pintura.
                </p>
              </div>

              <div className="row global-carousel testi-slider-1">
                <Swiper
                  loop={true}
                  navigation={{
                    nextEl: ".testimonialOne-button-next",
                    prevEl: ".testimonialOne-button-prev",
                  }}
                  spaceBetween={20}
                  slidesPerGroup={1}
                  speed={1000}
                  autoplay={{ delay: 6000 }}
                  pagination={true}
                  className="mySwiper"
                  modules={[FreeMode, Navigation, Thumbs, EffectFade]}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    500: { slidesPerView: 1 },
                    768: { slidesPerView: 1 },
                    992: { slidesPerView: 1 },
                    1200: { slidesPerView: 1 },
                    1400: { slidesPerView: 1 },
                  }}
                >
                  {/* Testimonio 1 */}
                  <SwiperSlide>
                    <div className="testi-card">
                      <div className="testi-card_content">
                        <div className="testi-card-profile">
                          <div className="testi-card-profile-details">
                            <h4 className="testi-profile-title">Carlos Méndez</h4>
                            <span className="testi-profile-desig">Cliente</span>
                          </div>
                          <div className="quote-icon">
                            <img
                              src="assets/img/icon/quote1-1.svg"
                              alt="Cita"
                            />
                          </div>
                        </div>
                        <p className="testi-card_text">
                          Mi experiencia con Leal fue excelente. El equipo
                          reparó la carrocería de mi auto de forma impecable,
                          y la pintura quedó como de fábrica. ¡Muy recomendados!
                        </p>
                        <div className="rating">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  {/* Testimonio 2 */}
                  <SwiperSlide>
                    <div className="testi-card">
                      <div className="testi-card_content">
                        <div className="testi-card-profile">
                          <div className="testi-card-profile-details">
                            <h4 className="testi-profile-title">María Fernanda</h4>
                            <span className="testi-profile-desig">Cliente</span>
                          </div>
                          <div className="quote-icon">
                            <img
                              src="assets/img/icon/quote1-1.svg"
                              alt="Cita"
                            />
                          </div>
                        </div>
                        <p className="testi-card_text">
                          Tenía varios rayones en mi coche y me preocupaba el
                          color. En Leal consiguieron el tono exacto y dejaron
                          mi auto como nuevo. ¡Un servicio excepcional!
                        </p>
                        <div className="rating">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>

                  {/* Testimonio 3 */}
                  <SwiperSlide>
                    <div className="testi-card">
                      <div className="testi-card_content">
                        <div className="testi-card-profile">
                          <div className="testi-card-profile-details">
                            <h4 className="testi-profile-title">Andrés López</h4>
                            <span className="testi-profile-desig">Cliente</span>
                          </div>
                          <div className="quote-icon">
                            <img
                              src="assets/img/icon/quote1-1.svg"
                              alt="Cita"
                            />
                          </div>
                        </div>
                        <p className="testi-card_text">
                          Necesitaba reparar un golpe fuerte en la puerta
                          trasera. Me sorprendió la calidad del trabajo y
                          sobre todo, la rapidez con la que lo entregaron.
                        </p>
                        <div className="rating">
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                          <i className="fas fa-star" />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                </Swiper>

                {/* Flechas de navegación del Swiper */}
                <div className="testimonialOne arrow">
                  <div className="testimonialOne-button-next testimonialOne-button">
                    <i className="fas fa-arrow-left"></i>
                  </div>
                  <div className="testimonialOne-button-prev testimonialOne-button">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </div>
              </div>
              {/* Fin del slider */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialOne;
